<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div class="top-container background">
  @if (!hideTopbar) {
  <app-topbar [title]="topbarText" [topbarView]="TopbarView.BLUEPRINT_HOME" [imageFilePath]="topbarImage"
    (urlNavigate)="topBarNavigate($event)"></app-topbar>
  }
  @if (isStarted) {
  <div class="card-container">
    @if (joinMselList.length > 0) {
    <mat-card appearance="outlined" [ngClass]="joinClass" tabindex="1" role="button" (click)="gotoUrl('join')"
      (mouseover)="joinClass='base-card outline'" (mouseout)="joinClass='base-card'">
      <mat-card-header>
        <mat-card-title>Join an Event</mat-card-title>
        <mat-card-subtitle>Access In-Progress Events</mat-card-subtitle>
      </mat-card-header>
      <img class="card-image" src="assets/img/join.png" alt="Join image">
    </mat-card>
    }
    @if (launchMselList.length > 0) {
    <mat-card appearance="outlined" [ngClass]="launchClass" tabindex="2" role="button" (click)="gotoUrl('launch')"
      (mouseover)="launchClass='base-card outline'" (mouseout)="launchClass='base-card'">
      <mat-card-header>
        <mat-card-title>Start an Event</mat-card-title>
        <mat-card-subtitle>Launch New events</mat-card-subtitle>
      </mat-card-header>
      <img class="card-image" src="assets/img/start.png" alt="Start image">
    </mat-card>
    }
    @if (buildMselList.length > 0 || canCreateMsels) {
    <mat-card appearance="outlined" [ngClass]="buildClass" tabindex="3" role="button" (click)="gotoUrl('build')"
      (mouseover)="buildClass='base-card outline'" (mouseout)="buildClass='base-card'">
      <mat-card-header>
        <mat-card-title>Manage an Event</mat-card-title>
        <mat-card-subtitle>Design and Plan Events</mat-card-subtitle>
      </mat-card-header>
      <img class="card-image" src="assets/img/build.png" alt="Build image">
    </mat-card>
    }
    @if (joinMselList.length === 0 && launchMselList.length === 0 && buildMselList.length === 0 && !canCreateMsels) {
    <mat-card appearance="outlined" [ngClass]="buildClass" tabindex="3" role="button">
      <mat-card-header>
        <mat-card-title>Nothing to see here!</mat-card-title>
      </mat-card-header>
      It appears that you do not have anything to access. If you believe this is an error, please contact you system
      administrator.
    </mat-card>
    }
  </div>
  }
  @if (!isStarted) {
  <div class="card-container">
    <mat-card appearance="outlined" [ngClass]="buildClass">
      <mat-card-header>
        <mat-card-title>Initializing Data</mat-card-title>
        <mat-card-subtitle>Please wait ...</mat-card-subtitle>
      </mat-card-header>
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
  </div>
  }
</div>
